"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exitTailContext = exports.tryEnterTailContext = exports.isParentInTailContext = exports.matchArgumentsToParameters = exports.apply = exports.extendEnvironmentWithNewBindings = exports.listOfArguments = exports.checkNumberOfArguments = void 0;
const errors = require("../errors/errors");
const stringify_1 = require("../utils/stringify");
const interpreter_1 = require("./interpreter");
const util_1 = require("./util");
const value_1 = require("./value");
const checkNumberOfArguments = (context, name, callSignature, numArgs, callExpression) => {
    if (callSignature.style === 'fixed-args' && callSignature.numParams !== numArgs) {
        util_1.handleRuntimeError(context, new errors.InvalidNumberOfArguments(callExpression, stringify_1.stringifyCallSignature(name, callSignature), callSignature.numParams, numArgs));
    }
    else if (callSignature.style === 'var-args' &&
        numArgs < callSignature.numCompulsoryParameters) {
        util_1.handleRuntimeError(context, new errors.NotEnoughArguments(callExpression, stringify_1.stringifyCallSignature(name, callSignature), callSignature.numCompulsoryParameters, numArgs));
    }
};
exports.checkNumberOfArguments = checkNumberOfArguments;
function* listOfArguments(expressions, context) {
    const values = [];
    for (const expression of expressions) {
        values.push(yield* interpreter_1.evaluate(expression, context));
    }
    return values;
}
exports.listOfArguments = listOfArguments;
const extendEnvironmentWithNewBindings = (context, environment, procedureName, paramArgPairs) => {
    const frame = {};
    const newEnvironment = {
        name: procedureName,
        tail: environment,
        head: frame,
        procedureName: '(' + [procedureName, ...paramArgPairs.map(pair => stringify_1.stringify(pair.argument))].join(' ') + ')'
    };
    paramArgPairs.forEach(pair => util_1.introduceBinding(context, frame, pair.parameter.isFromSource, pair.parameter.value, pair.argument));
    return newEnvironment;
};
exports.extendEnvironmentWithNewBindings = extendEnvironmentWithNewBindings;
function* apply(context, procedure, suppliedArgs, node) {
    while (true) {
        exports.checkNumberOfArguments(context, procedure.name, procedure.callSignature, suppliedArgs.length, node);
        let result;
        if (procedure.variant === 'CompoundProcedure') {
            result = yield* applyCompoundProcedure(context, procedure, suppliedArgs);
        }
        else {
            result = yield* applyBuiltInProcedure(context, procedure, suppliedArgs, node);
        }
        if (result.type !== 'TailCall') {
            return result;
        }
        procedure = result.procedure;
        suppliedArgs = result.args;
        node = result.node;
    }
}
exports.apply = apply;
function* applyCompoundProcedure(context, procedure, suppliedArgs) {
    const environment = exports.extendEnvironmentWithNewBindings(context, procedure.environment, procedure.name, exports.matchArgumentsToParameters(procedure.callSignature, suppliedArgs));
    util_1.pushEnvironment(context, environment);
    if (procedure.body.length === 0) {
        return util_1.handleRuntimeError(context, new errors.UnreachableCodeReached('lambda body should have one or more expressions'));
    }
    for (let i = 0; i < procedure.body.length - 1; i++) {
        const expression = procedure.body[i];
        yield* interpreter_1.evaluate(expression, context);
    }
    // If tail call optimization is enabled,
    // enter tail context before evaluating the last expression
    const lastExpression = procedure.body[procedure.body.length - 1];
    if (context.variant !== 'no-tco') {
        enterTailContext(context);
    }
    const result = yield* interpreter_1.evaluate(lastExpression, context);
    exports.exitTailContext(context);
    util_1.popEnvironment(context);
    return result;
}
function* applyBuiltInProcedure(context, procedure, suppliedArgs, node) {
    try {
        const result = procedure.body(suppliedArgs, context);
        if ('next' in result && 'throw' in result) {
            return yield* result;
        }
        else {
            return result;
        }
    }
    catch (e) {
        return util_1.handleRuntimeError(context, new errors.BuiltinProcedureError(e, node));
    }
}
/** Match the arguments with parameters according to the call signature. */
const matchArgumentsToParameters = (callSignature, args) => {
    if (callSignature.style === 'fixed-args') {
        return callSignature.parameters.map((parameter, index) => ({
            parameter,
            argument: args[index]
        }));
    }
    else {
        return callSignature.compulsoryParameters
            .map((parameter, index) => ({ parameter, argument: args[index] }))
            .concat({
            parameter: callSignature.restParameters,
            argument: value_1.makeList(args.slice(callSignature.numCompulsoryParameters))
        });
    }
};
exports.matchArgumentsToParameters = matchArgumentsToParameters;
/**
 * Check whether the parent node is in tail context
 */
const isParentInTailContext = (context) => {
    return context.runtime.inTailContext.length >= 2 && context.runtime.inTailContext[1];
};
exports.isParentInTailContext = isParentInTailContext;
/** Unconditionally enter tail context.
 * Note that this function is intentionally unexported
 * because we can enter tail context unconditionally only
 * at the end of a procedure call, which happens only within this file. */
const enterTailContext = (context) => {
    context.runtime.inTailContext[0] = true;
};
/** Enter tail context for the current node only if parent node is in tail context */
const tryEnterTailContext = (context) => {
    if (exports.isParentInTailContext(context)) {
        enterTailContext(context);
    }
};
exports.tryEnterTailContext = tryEnterTailContext;
/** Exit tail context for the current node */
const exitTailContext = (context) => {
    context.runtime.inTailContext[0] = false;
};
exports.exitTailContext = exitTailContext;
//# sourceMappingURL=procedure.js.map